<template>
  <div>
    <!-- Search -->
    <h1 class="title">Search Simulations</h1>

    <div class="field has-addons">
      <div class="control">
        <input
          class="input"
          type="text"
          placeholder="Enter title"
          v-model="searchStr"
          v-on:input="onInput"
        />
      </div>
      <div class="control">
        <button class="button is-primary">
          <span class="icon">
            <font-awesome-icon icon="search" />
          </span>
        </button>
      </div>
    </div>

    <Loader v-bind:isLoading="isLoading" />

    <div v-show="isActive">
      <ul>
        <li v-for="sim in results" :key="sim.id">
          <router-link
            class="has-text-weight-bold"
            :to="{ name: 'result', params: { id: sim.id } }"
          >{{ sim.title }}</router-link>
          - {{ sim.created_at | formatDate }}
        </li>
      </ul>
      <p v-if="(hasData && results.length === 0)">No results.</p>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import apiCall from '../lib/remote-calls';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      hasData: false,
      isActive: false,
      isLoading: false,
      simulations: [],
      searchStr: '',
      results: [],
    };
  },
  methods: {
    async onInput() {
      if (this.searchStr.length > 0) {
        if (!this.hasData && !this.isLoading) {
          await this.requestSimulations();
        }
        this.isActive = true;
        this.filterResults();
      } else {
        this.isActive = false;
      }
    },
    filterResults() {
      this.results = this.simulations.filter(
        (item) => item.title.toLowerCase().indexOf(this.searchStr.toLowerCase()) > -1,
      );
    },
    async requestSimulations() {
      this.isLoading = true;
      try {
        const response = await apiCall('GET', 'simulations');
        this.simulations = response.data.simulations;
        this.hasData = true;
      } catch (error) {
        console.error('error', error);
      }
      this.isLoading = false;
    },
  },
};
</script>
<style scoped>
h1.title {
  margin-top: 1em;
}
div.field {
  margin-top: 1.5em;
  margin-bottom: 1.5em;
}
ul {
  list-style: disc inside;
  padding-bottom: 0.5em;
}
ul > li:not(:last-child) {
  padding-bottom: 0.5em;
}
</style>
